module.exports = __webpack_public_path__ + "media/images/elenstil-79cd5c74cba4d0953a54119aacf23f74.svg";